<template>
  <el-dialog title="审批" class="global-dialog" :visible.sync="visible" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form" v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="approvalRules" ref="form2" label-width="130px">
        <!-- 云采财务审核沿用申请单资料，不再重复录入充值或退还的金额、银行及日期。 -->
        <el-form-item prop="approvalStatus" label="审批状态">
          <el-radio-group v-model="formData.approvalStatus" @change="approvalStatusChange">
            <el-radio label="2">审核通过</el-radio>
            <el-radio label="3">审核驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="approvalComments" label="审批意见">
          <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入审批意见"
            v-model="formData.approvalComments">
          </el-input>
        </el-form-item>
        <template v-if="depositType === '1' && approvalStatus === '2'">
          <el-form-item label="付款凭证" prop="fileList">
            <file-upload v-model="formData.fileList"></file-upload>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="附件">
            <file-upload v-model="formData.fileList"></file-upload>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>
    <!-- <image-viewer :visible.sync="dialogVisible" :initial-index="currentImageIndex" :url-list="imageList"></image-viewer> -->

  </el-dialog>
</template>
<script>
export default {
  name: 'FundApprovalDialog',
  props: {
    relatedId: {
      type: String,
      default: ''
    },
    depositType: {
      type: String, // 1：充值 2：退还 3：转换
      default: ''
    },
    approvalStatus: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  data() {
    return {
      skyhList: [],
      statusList2: [
        {
          label: '审批通过',
          value: '2'
        },
        {
          label: '审批驳回',
          value: '3'
        }
      ],
      formData: {
        relatedId: '',
        approvalStatus: '',
        approvalComments: '', // 审批意见
        fileList: []
      },
      rules: {
        approvalStatus: [
          {
            required: true,
            message: '请选择审批状态',
            trigger: ['blur', 'change']
          }
        ],
        approvalComments: [
          {
            required: true,
            message: '请输入审批意见',
            trigger: ['blur', 'change']
          }
        ],
        fileList: [
          {
            required: true,
            message: '请上传付款凭证',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    }
  },
  computed: {
    approvalRules() {
      const rules = { approvalStatus: this.rules.approvalStatus }
      // 仅充值、退还的财务节点意见选填，其他业务审批继续执行原有意见校验。
      const financeApproval = this.approvalStatus === '2' && ['1', '2'].includes(this.depositType)
      if (!financeApproval) rules.approvalComments = this.rules.approvalComments
      // 财务审核充值通过仍须上传付款凭证，驳回和退还不强制上传附件。
      if (financeApproval && this.depositType === '1' && this.formData.approvalStatus === '2') {
        rules.fileList = this.rules.fileList
      }
      return rules
    }
  },
  created() {
    this.loadDict()
  },
  methods: {
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'skyh' }
      }).then(res => {
        this.skyhList = res.skyh || []
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    approvalStatusChange(val) {
      if (val === '3') {
        this.$refs.form2.clearValidate()
      }
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        this.formData.relatedId = this.relatedId
        this.$axios.post(this.$apis.yxcBondRecord.approvaYxcUserDepositNew, this.formData).then(() => {
          this.$emit('success')
          this.handleClose()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
